import { render, staticRenderFns } from "./MianZeTiaoKuanView.vue?vue&type=template&id=09febafc&scoped=true"
import script from "./MianZeTiaoKuanView.vue?vue&type=script&lang=js"
export * from "./MianZeTiaoKuanView.vue?vue&type=script&lang=js"
import style0 from "./MianZeTiaoKuanView.vue?vue&type=style&index=0&id=09febafc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09febafc",
  null
  
)

export default component.exports